import { createContext, useContext } from 'react';
export const FrameContext = createContext(undefined);
export function useFrameContext() {
    const context = useContext(FrameContext);
    if (context === undefined) {
        throw new Error('useFrameContext must be used within a FrameProvider');
    }
    return context;
}
//# sourceMappingURL=FrameContext.js.map